import { call, take, cancel, cancelled, fork } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import firebase from 'firebase/app';
import 'firebase/database';

const createEventChannel = (pathToListen, eventType) => {
  const listener = eventChannel(emit => {
    const itemsRef = firebase.database().ref(pathToListen);
    const event = data => emit(data);
    itemsRef.on(eventType, event);
    return () => itemsRef.off(eventType, event);
  });

  return listener;
};

const whatchLiveChannel = function*({
  entity,
  eventType,
  handler,
  pathToListen,
  skipFirstRound,
  metadata,
}) {
  const eventChannel = yield call(createEventChannel, pathToListen, eventType);
  try {
    let shouldHandleData = !skipFirstRound;
    while (true) {
      const data = yield take(eventChannel);
      // console.log(`whatchLiveChannel: pathToListen = ${pathToListen}, DATA =`, data);
      if (!shouldHandleData) {
        shouldHandleData = true;
        // console.log('whatchLiveChannel: skip handler: ', pathToListen);
        continue;
      }
      yield fork(handler, data, entity, metadata);
    }
  } finally {
    if (yield cancelled()) {
      eventChannel.close();
    }
  }
};

export const createDynamicLiveChannel = function*({
  closeChannelAction,
  eventType,
  handler,
  entity,
  pathToListen,
  skipFirstRound,
  metadata = {},
}) {
  let task = yield fork(whatchLiveChannel, {
    entity,
    eventType,
    handler,
    pathToListen,
    skipFirstRound,
    metadata,
  });

  while (true) {
    const { payload: newEntity } = yield take(closeChannelAction);
    if (newEntity === entity) {
      yield cancel(task);
      break;
    }
  }
};
